import React from "react";
import {
  h4Medium,
  h5Regular,
  h6Medium,
  h7Regular,
} from "../../../shared/constants";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/core";

import { ReactComponent as DeliveryTruckIcon } from "../../../assets/deliveryTruck.svg";
import { ReactComponent as BasketCheckIcon } from "../../../assets/basketCheck.svg";
import { ReactComponent as HealthIcon } from "../../../assets/health.svg";
import { ReactComponent as NavigationIcon } from "../../../assets/navigation.svg";

const iconsContainer = {
  basketCheck: <BasketCheckIcon />,
  helth: <HealthIcon />,
  navigation: <NavigationIcon />,
  deliveryTruck: <DeliveryTruckIcon />,
};

const useStyles = makeStyles({
  container: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    position: "relative",
    width: "100%",
    background: "#FFFFFF",
    height: 400,
  },
  innerDiv: {
    minHeight: 50,
    width: 310,
    marginRight: 40,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    alignContent: "center",
    textAlign: "center",
    "@media (max-width:940px)": {
      width: 165,
    },
    "&:last-child": {
      marginRight: 0,
    }
  },
  title: {
    ...h4Medium,
    marginTop: 32,
    opacity: 0.72,
    "@media (max-width:940px)": {
      ...h6Medium,
      marginTop: 16,
    },
  },
  description: {
    marginTop: 16,
    opacity: 0.64,
    ...h5Regular,
    "@media (max-width:940px)": {
      ...h7Regular,
      marginTop: 8,
    },
  },
});

const SixthAboutSect = () => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <div className={classes.background}></div>
      {["basketCheck", "helth", "navigation", "deliveryTruck"].map(
        (text, index) => {
          return (
            <div className={classes.innerDiv} key={text}>
              {iconsContainer[text]}
              <span className={classes.title}>
                {t(`home.titlesContainer.${text}`)}
              </span>
              <span className={classes.description}>
                {t(`home.descsContainer.${text}`)}
              </span>
            </div>
          );
        }
      )}
    </div>
  );
};

export default SixthAboutSect;
